import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-grow bg-white relative flex-1 pb-16" }
const _hoisted_2 = { class: "hidden overflow-hidden [overflow-anchor:none] 2xl:block 2xl:absolute 2xl:inset-y-0 2xl:h-full 2xl:w-full" }
const _hoisted_3 = {
  class: "relative h-full text-lg max-w-prose mx-auto",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  key: 0,
  class: "absolute top-12 left-full translate-x-32 transform",
  width: "404",
  height: "384",
  fill: "none",
  viewBox: "0 0 404 384"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "74b3fd99-0a6f-4271-bef2-e80eeafdf357",
    x: "0",
    y: "0",
    width: "20",
    height: "20",
    patternUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "4",
      height: "4",
      class: "text-gray-200",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  width: "404",
  height: "384",
  fill: "url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<svg class=\"absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32\" width=\"404\" height=\"384\" fill=\"none\" viewBox=\"0 0 404 384\"><defs><pattern id=\"f210dbf6-a58d-4871-961e-36d5016a0f49\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" patternUnits=\"userSpaceOnUse\"><rect x=\"0\" y=\"0\" width=\"4\" height=\"4\" class=\"text-gray-200\" fill=\"currentColor\"></rect></pattern></defs><rect width=\"404\" height=\"384\" fill=\"url(#f210dbf6-a58d-4871-961e-36d5016a0f49)\"></rect></svg><svg class=\"absolute bottom-12 left-full transform translate-x-32\" width=\"404\" height=\"384\" fill=\"none\" viewBox=\"0 0 404 384\"><defs><pattern id=\"d3eb07ae-5182-43e6-857d-35c643af9034\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" patternUnits=\"userSpaceOnUse\"><rect x=\"0\" y=\"0\" width=\"4\" height=\"4\" class=\"text-gray-200\" fill=\"currentColor\"></rect></pattern></defs><rect width=\"404\" height=\"384\" fill=\"url(#d3eb07ae-5182-43e6-857d-35c643af9034)\"></rect></svg>", 2)
const _hoisted_10 = { class: "flex flex-col justify-between flex-1" }
const _hoisted_11 = { class: "relative flex justify-center gap-6 px-4 sm:px-6 lg:px-8" }
const _hoisted_12 = { class: "w-80 not-prose hidden 2xl:block" }
const _hoisted_13 = { class: "prose prose-indigo prose-lg text-gray-500 min-w-0 max-w-[46rem]" }
const _hoisted_14 = { class: "w-80 not-prose hidden xl:block" }

import { PropType } from 'vue';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPage',
  props: {
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: (encodedDomain: string) => `/domains/${encodedDomain}/dns-records/`,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent, {
      "domain-search-to-url": __props.domainSearchToUrl,
      "search-button-text": __props.searchButtonText
    }, null, 8, ["domain-search-to-url", "search-button-text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.$slots['aside-right'])
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_7))
            : _createCommentVNode("", true),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("aside", _hoisted_12, [
            _renderSlot(_ctx.$slots, "aside-left")
          ]),
          _createElementVNode("main", _hoisted_13, [
            _renderSlot(_ctx.$slots, "content")
          ]),
          _createElementVNode("aside", _hoisted_14, [
            _renderSlot(_ctx.$slots, "aside-right")
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})